/**
 * Card geometry, in one place.
 *
 * The height of a node card is not a constant: a card carrying evaluation tags
 * or a research score is taller, and an expanded one is taller again. Anything
 * that has to sit *on* a card — the link handle on its top edge, for one — has
 * to ask the same question the renderer asks, or it lands inside the card on
 * every node that grew.
 *
 * This is the same shape as blockerCardMetrics.js and exists for the same
 * reason: two places computing geometry from the same data will not stay in
 * agreement by being careful.
 */

export const NODE_CARD_WIDTH = 360;
export const NODE_CARD_BASE_HEIGHT = 90;
export const NODE_CARD_SCORED_HEIGHT = 110;
export const NODE_CARD_EXPANDED_HEIGHT = 400;

/** True when the card shows research/tag scores — starters never do. */
export function nodeHasScores(node) {
  if (!node || node.is_scenario_starter) return false;
  const analysis = node.node_analysis;
  if (!analysis) return false;
  return Boolean(
    (analysis.version === 2 && analysis.tags?.length)
    || analysis.scores?.research_support != null
    || analysis.research_support != null,
  );
}

export function nodeCardHeight(node, { isExpanded = false, description = null } = {}) {
  const desc = description ?? node?.description;
  const hasDescription = desc && desc !== 'None' && desc !== 'null' && String(desc).trim();
  if (isExpanded && hasDescription) return NODE_CARD_EXPANDED_HEIGHT;
  return nodeHasScores(node) ? NODE_CARD_SCORED_HEIGHT : NODE_CARD_BASE_HEIGHT;
}
